export default class UploadService {

}
